import script from "./CoreProgramKpiTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreProgramKpiTable.vue?vue&type=script&setup=true&lang=js"

import "./CoreProgramKpiTable.vue?vue&type=style&index=0&id=3150dbc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3150dbc6"]])

export default __exports__